//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      pager:{
        page: '1',
        pageCount: '1',

      },
      parPage: '1',
      parCount: '4',
      listArrs : []
    }
  },
  mounted(){
    this.finaceList()
  },
  methods: {
    finaceList(){
      let data = 'cmd=free_delay_list&page='+this.parPage+'&count='+this.parCount+'&ptype=vhost';
      this.$http.post('https://api.abeiyun.com/www/renew.php',data).then(({data})=>{
        if(data.response==200){
          this.listArrs = data.msg;
          this.pager.page= data.msg.curpage
          this.pager.pageCount = data.msg.allpage
        }
      })
    },
    pageNum(n,par){
      if(par=='up'){

        if(n>1){
          n = n-1;
          this.parPage = n
          this.parCount = '4';
          this.finaceList();
        }
      }else if(par=='down'){
        if(n<this.pager.pageCount){
          n = parseInt(n)+1;
          this.parPage = n
          this.parCount = '4';

          this.finaceList();
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/console/vhostrecord.vue